







































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BasePagination from '@/base/BasePagination.vue';
import TheTableProducts from '@/components/products/TheTableProducts.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing function
import {getProducts} from '@/ts/products/get-products';

export default {
    name: 'PageCategories',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableProducts,
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            items: Array(),
            search_param: String(),
        };
    },
    methods: {},
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Категории',
            to: { name: 'categories', params: { id: this.$route.params.id} },
        }, {
            text: 'Продукти',
        }];
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        // Fetching data from the API
        if (this.$route.params.category_id === undefined) {
            this.$route.params.category_id = '';
        }
        this.$store.dispatch('setLoadingOn');
        getProducts(this.$route.params.id, this.$route.params.category_id).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
